function InstructionCard(props) {
    let step = props.step
    return (

        <div id={props.id} className='instruction-card card container-dark w-80 h-100'>
            
            <img src={step.image} className='modal-img card-img-top pb-2'></img>
            <span className='badge step-info rounded-pill text-dark fs-4 w-50 mx-auto'>{step.step}</span>
            <h4 className='card-title text-light fs-4 pt-2 text-center'>{step.card_title}</h4>
            <div className='instruction-text card-text text-light fs-5'>{step.card_text}</div>

        </div>

    );
}
export default InstructionCard